import React from "react";
import { FiUpload } from "react-icons/fi";
import { GenPoint } from "../domain/types";
import { parseGenCsv } from "../domain/csv";

export const GenProfileUpload: React.FC<{
  value: GenPoint[];
  onChange: (rows: GenPoint[]) => void;
  required?: boolean;
  isExisting?: boolean;
}> = ({ value, onChange, required, isExisting }) => {
  const handle = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const f = e.target.files?.[0];
    if (!f) return;
    const rows = await parseGenCsv(f);
    onChange(rows);
  };

  return (
    <section className="relative">
      <hr className="mb-8 border-t border-border" />
      <h4 className="mb-3 text-body font-semibold text-quantum-400">
        Hourly Generation Profile {required && <span className="text-health-400 ml-1">*</span>}
      </h4>
      <div className="flex flex-col gap-2">
        <label
          htmlFor="gen_csv"
          className={`inline-flex items-center gap-2 px-4 py-2 border rounded-lg cursor-pointer text-body-sm font-medium transition-colors ${value.length > 0
              ? "text-quantum-400 border-quantum-500/40 bg-quantum-500/10 hover:bg-quantum-500/20"
              : "text-health-400 border-health-500/40 bg-health-500/10 hover:bg-health-500/20"
            }`}
        >
          <FiUpload className="w-5 h-5" /> Upload CSV
        </label>
        <input id="gen_csv" type="file" accept=".csv" className="hidden" onChange={handle} required={!!required} />
        {value.length > 0 ? (
          <span className="text-quantum-400 text-body-sm">{value.length} rows loaded</span>
        ) : (
          <span className="text-health-400 text-body-sm">{isExisting ? "Required for operating projects" : "Optional — overrides SAM profile"}</span>
        )}
      </div>
    </section>
  );
};
